import type { User } from '@pay-plan/shared';

// TODO perf: each consuming page independently calls useApi(listUsers, []),
// which means a ~20-25 KB users payload is fetched per page mount. A future
// pass could hoist this into AuthContext so every consumer shares one map.
// Kept per-page for now to match the established convention in the codebase
// (AssignmentPage, PaySheetPage, and all report pages already do this).

export function userDisplayNameMap(users: User[] | null): Map<string, string> {
  const map = new Map<string, string>();
  for (const u of users ?? []) {
    map.set(u.userId, u.displayName);
  }
  return map;
}

export function formatUserName(userId: string | undefined, map: Map<string, string>): string {
  if (userId === undefined || userId === '') return '—';
  const name = map.get(userId);
  if (name !== undefined && name !== '') return name;
  // Truncate the UUID so it's still debuggable but doesn't dominate UI width.
  return userId.length > 8 ? `${userId.slice(0, 8)}…` : userId;
}
